import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { Logger } from '@core/services/logger.service';
import { IndeterminateCircularProgressIndicatorComponent } from '@shared/components/indeterminate-circular-progress-indicator/indeterminate-circular-progress-indicator.component';
import { CassDynamicOverlay } from '@shared/services/dynamic-overlay.service';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Directive({
	selector: '[cassIndeterminateOverlayProgressIndicator]'
})
export class IndeterminateOverlayProgressIndicatorDirective implements OnInit {

	private readonly COMPONENT_NAME = "IndeterminateOverlayProgressIndicatorDirective";

	@Input('cassIndeterminateOverlayProgressIndicator')
	toggler: Observable<boolean> | undefined;

	private overlayRef?: OverlayRef;

	constructor(
		private logger: Logger,
		private host: ElementRef,
		private dynamicOverlay: CassDynamicOverlay) { }

	ngOnInit() {

		this.overlayRef = this.dynamicOverlay.createWithDefaultConfig(
			this.host.nativeElement
		);

		if (!this.toggler) {
			this.logger.warning(this.COMPONENT_NAME, "The directive is used but the toggler is not provided");
			return;
		}

		this.toggler.pipe(distinctUntilChanged()).subscribe(show => {
			if (show) {
				this.overlayRef?.attach(new ComponentPortal(IndeterminateCircularProgressIndicatorComponent));
			}
			else {
				this.overlayRef?.detach();
			}
		});
	}
}
